import { APP_ENGAGEMENT_OPTS } from '../../helpers/utils.js'
import { TYPES } from '../actions/userAction'

const {
  LOGIN_USER_START,
  LOGIN_USER_COMPLETE,
  LOGIN_USER_ERROR,
  FORGOT_PASS_EMAIL_VERIFY_START,
  FORGOT_PASS_EMAIL_VERIFY_COMPLETE,
  FORGOT_PASS_EMAIL_VERIFY_ERROR,
  FORGOT_PASS_CHANGE_PASSWORD_START,
  FORGOT_PASS_CHANGE_PASSWORD_COMPLETE,
  FORGOT_PASS_CHANGE_PASSWORD_ERROR,
  LOGOUT_USER,
  CLEAR_ERROR,
  SET_ALERT,
  FETCHED_APP_ENGAGEMENT,
  FETCHED_APP_ENGAGEMENT_ERROR,
} = TYPES

const initialState = {
  token: localStorage.getItem('token'),
  refreshToken: localStorage.getItem('refreshToken'),
  engagement: null,
  email: null,
  name: null,
  config: null,
  //Added for changing user role and status
  //isAdmin: null,
  role: null,
  isLoading: false,
  error: false,
  msg: null,
  access: {},
  appEngagement: APP_ENGAGEMENT_OPTS.FETCHING_ENGAGEMENT_TEXT,
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_ERROR:
      return {
        ...state,
        error: false,
        msg: null
      }

    case SET_ALERT:
      return {
        ...state,
        error: action.data.error,
        msg: action.data.msg
      }

    case LOGIN_USER_START:
      return { ...state, isLoading: true }
    case LOGIN_USER_COMPLETE:
      return {
        ...state,
        token: action.data.token,
        refreshToken: action.data.refreshToken,
        email: action.data.email,
        name: action.data.name,
        config: action.data.config,
        engagement: action.data.engagement,
        //Added for changing user role and status
        //isAdmin: action.data.isAdmin,
        role: action.data.role,
        access: action.data.access,
        isLoading: false
      }
    case LOGIN_USER_ERROR:
      return { ...state, isLoading: false, error: true, msg: action.data }
    case FORGOT_PASS_EMAIL_VERIFY_START:
      return { ...state, email: action.data.email, isLoading: true }
    case FORGOT_PASS_EMAIL_VERIFY_COMPLETE:
      return { ...state, isLoading: false }
    case FORGOT_PASS_EMAIL_VERIFY_ERROR:
      return { ...state, isLoading: false }
    case FORGOT_PASS_CHANGE_PASSWORD_START:
      return {
        ...state,
        email: action.data.email,
        password: action.data.password,
        isLoading: true
      }
    case FORGOT_PASS_CHANGE_PASSWORD_COMPLETE:
      return { ...state, isLoading: false }
    case FORGOT_PASS_CHANGE_PASSWORD_ERROR:
      return { ...state, isLoading: false }
    case LOGOUT_USER:
      return {
        ...state,
        token: null,
        refreshToken: null,
        email: null,
        name: null,
        role: null
      }
    case FETCHED_APP_ENGAGEMENT: 
      return {
        ...state,
        appEngagement: action.data,
        isLoading: false
      }
    case FETCHED_APP_ENGAGEMENT_ERROR:
      return {
        ...state,
        appEngagement: APP_ENGAGEMENT_OPTS.FETCH_ENGAGEMENT_ERROR,
        isLoading: false
      }
    default:
      return state
  }
}

export default userReducer
